<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-num"><a href="#/9781617750502_Split8#toc3" id="ch3"><b>1965</b></a></p>
<p class="chap-ttl"><a href="#/9781617750502_Split8#toc4" id="ch4">HOME (original introduction)</a></p>
<p class="tx1"><span>T</span>hese essays are placed chronologically (from 1960 to 1965), to show just how my mind and my place in America have changed since the “Cuba Libre” essay.</p>
<p class="tx">I have been a lot of places in my time, and done a lot of things. And there is a sense of the Prodigal about my life that begs to be resolved. But one truth anyone reading these pieces ought to get is the sense of movement— the struggle, in myself, to understand where and who I am, and to move with that understanding. (As, for example, the difference in out- and in-look between “The Myth of a ‘Negro Literature’” and “Black Writing”; or a liberal piece like “Tokenism: 300 Years for Five Cents” and the changed thinking that evolved into “The Revolutionary Theatre” or “American Sexual Reference: Black Male.”) And these moves, most times unconscious (until, maybe, I’d look over something I’d just written and whistle, “Yow, yeh, I’m way over there, huh?”), seem to me to have been always toward the thing I had coming into the world, with no sweat: my blackness.</p>
<p class="tx">There were all kinds of roadblocks. Having read all of whitie’s books, I wanted to be an authority on them. Having been taught that art was “what white men do,” I almost became one, to have a go at it. Having been the only “middle-class” chump running with the Hillside Place bads, I was “saved” from them by my parents’ determination and the cool scholarship game which turns stone killers pure alabaster by graduation time. Having been born October 7, my nature was to listen to everybody, to be sensitive to, and look at, everything.</p>
<p class="tx">But my tendency, body and mind, is to make it. To get there, from anywhere, going wherever, always. By the time this book appears, I will be even blacker.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781617750502_Split10.vue?36f04be3